import React from 'react';
import styles from './AnimatedVisuals.module.css';

const ChatbotVisual = () => {
  return (
    <div className={styles.visualContainer}>
      <div className={styles.chatbotHeader}>
        <div className={styles.chatbotIcon}>💬</div>
        <span className={styles.chatbotTitle}>AI Chatbot</span>
      </div>
      <div className={styles.chatContainer}>
        <div className={styles.chatBubble} style={{ animationDelay: '0s' }}>
          <div className={styles.bubbleContent}>Hello! How can I help you today?</div>
        </div>
        <div className={styles.chatBubble} style={{ animationDelay: '1s' }}>
          <div className={styles.bubbleContent}>I'm here 24/7 to assist you.</div>
        </div>
        <div className={styles.chatBubble} style={{ animationDelay: '2s' }}>
          <div className={styles.bubbleContent}>Let me find the best solution...</div>
        </div>
        <div className={styles.typingIndicator}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
};

export default ChatbotVisual;

